import React from 'react'
import "./MemberView.css"

const MemberCardRight = (props) => {
    console.log(props?.member)

    return (
        <>
            <div className="member-card-right">
                <legend><h2>DETAILED INFORMATION</h2></legend>
                <div className="member-details">
                    <div className="detail-info">
                        <h2>PF NUMBER :</h2>
                        <h3>{props?.member?.pf_number}</h3>
                    </div>
                    <div className="detail-info">
                        <h2>REGION :</h2>
                        <h3>{props?.member?.region}</h3>
                    </div>
                </div>

                <div className="member-details">
                    <div className="detail-info">
                        <h2>NDC NUMBER : </h2>
                        <h3>{props?.member?.ndc_membership_number}</h3>
                    </div>
                    <div className="detail-info">
                        <h2>CONSTITUENCY :</h2>
                        <h3>{props?.member?.constituency}</h3>
                    </div>
                </div>
                <div className="member-details">
                    <div className="detail-info">
                        <h2>VOTER ID :</h2>
                        <h3> {props?.member?.voter_id_number}</h3>
                    </div>
                    <div className="detail-info">
                        <h2>BRANCH : </h2>
                        <h3>{props?.member?.branch}</h3>
                    </div>
                </div>
                <div className="member-details">
                    <div className="detail-info">
                        <h2>DATE OF BIRTH : </h2>
                        <h3>{props?.member?.date_of_birth}</h3>
                    </div>
                    <div className="detail-info">
                        <h2>QUALIFICATION TYPE : </h2>
                        <h3>{props?.member?.qualification_type}</h3>
                    </div>
                </div>
                <div className="member-details">
                    <div className="detail-info">
                        <h2>GENDER : </h2>
                        <h3>{props?.member?.gender}</h3>
                    </div>
                    <div className="detail-info">
                        <h2>QUALIFICATION : </h2>
                        <h3>{props?.member?.qualification}</h3>
                    </div>
                </div>
                <div className="member-details">
                    <div className="detail-info">
                        <h2>MARITAL STATUS : </h2>
                        <h3>{props?.member?.marital_status}</h3>
                    </div>
                    <div className="detail-info">
                        <h2>PROFESSION : </h2>
                        <h3>{props?.member?.profession}</h3>
                    </div>
                </div>
                <div className="member-details">
                    <div className="detail-info">
                        <h2>MOBILE NUMBER : </h2>
                        <h3>{props?.member?.mobile_number}</h3>
                    </div>
                    <div className="detail-info">
                        <h2>OCCUPATION : </h2>
                        <h3>{props?.member?.occupations}</h3>
                    </div>
                </div>
                <div className="member-details">
                    <div className="detail-info">
                        <h2>EMAIL ADDRESS : </h2>
                        <h3>{props?.member?.email}</h3>
                    </div>
                    <div className="detail-info">
                        <h2>EMPLOYMENT TYPE : </h2>
                        <h3>{props?.member?.employment_type}</h3>
                    </div>
                </div>
                <div className="member-details">
                    <div className="detail-info">
                        <h2>DATE JOINRD : </h2>
                        <h3>{props?.member?.date_joined}</h3>
                    </div>
                    <div className="detail-info">
                        <h2>CURRENT EMPLOYMENT : </h2>
                        <h3>{props?.member?.current_employment}</h3>
                    </div>
                </div>
            </div>
        </>
    )
}

export default MemberCardRight